import { defineComponent, onMounted, onUnmounted } from 'vue';
import { SurveyQuestion } from '@studyportals/sp-lurch-interface';
import ReviewUploadModalQuestion from '@/presentation/components/review-upload-modal-question/review-upload-modal-question.vue';
import ReviewUploadModalComponent from '@/presentation/components/review-upload-modal/review-upload-modal-class';

export default defineComponent({
	components: {
		ReviewUploadModalQuestion
	},
	props: {
		surveyQuestions: {
			type: Array as () => SurveyQuestion[],
			required: true
		}
	},
	setup: (props) => {
		const component = new ReviewUploadModalComponent(props.surveyQuestions);

		onMounted(component.mounted.bind(component));
		onUnmounted(component.unmounted.bind(component));

		return {
			surveyQuestions: component.surveyQuestions,
			firstBatchOfSurveyQuestions: component.firstBatchOfSurveyQuestions,
			secondBatchOfSurveyQuestions: component.secondBatchOfSurveyQuestions,
			modalContent: component.modalContent,
			modalReviewUploadState: component.modalReviewUploadState,
			isModalStepUploadScopeAndType: component.isModalStepUploadScopeAndType,
			isModalStepUploadContents: component.isModalStepUploadContents,
			closeModal: component.closeModal.bind(component),
			storeQuestionAnswer: component.storeQuestionAnswer.bind(component),
			showUploadScopeAndTypeScreen: component.showUploadScopeAndTypeScreen.bind(component),
			showUploadContentsScreen: component.showUploadContentsScreen.bind(component),
			retrieveAnswerOfQuestion: component.retrieveAnswerOfQuestion.bind(component)
		};
	}
});
